module.exports = __webpack_public_path__ + "static/media/NemeanLion.a2db3227.jpg";